import React from "react";
import { motion } from "framer-motion";
import { products } from "../Data";

const Products = () => {

  // Section stagger
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.2,
      },
    },
  };

  // Fade only
  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  // Card animation (safe)
  const cardAnim = {
    hidden: { opacity: 0, scale: 0.98 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  // Image subtle zoom
  const imageAnim = {
    hidden: { scale: 1.04 },
    visible: {
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  // Features stagger (inside card only)
  const featureContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.06,
      },
    },
  };

  const featureItem = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.3 },
    },
  };

  return (
    <section className="products-section container" id="products">

      {/* DOTS (slightly calmer) */}
      <motion.div
        className="product-dots-1 product-dots"
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.5, 0.9, 0.5],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <motion.div
        className="product-dots-2 product-dots"
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.5, 0.9, 0.5],
        }}
        transition={{
          duration: 3,
          delay: 0.6,
          repeat: Infinity,
        }}
      />

      {/* TEXT */}
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h3 className="section-subheading" variants={fade}>
          Select based on your surface and application needs.
        </motion.h3>

        <motion.h2 className="section-heading" variants={fade}>
          Choose the Right Adhesive for Your Project
        </motion.h2>
      </motion.div>

      {/* GRID */}
      <motion.div
        className="product-grid"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {products.map((item, index) => (
          <motion.div
            key={index}
            className={`product-card ${item.theme}`}
            variants={cardAnim}
            whileHover={{ scale: 1.015 }} // very controlled
            transition={{ duration: 0.2 }}
          >

            {/* IMAGE */}
            <div className="product-image-wrapper">
              <motion.img
                src={item.img}
                alt={`${item.title} | VigoFlex`}
                className="product-image"
                variants={imageAnim}
              />
            </div>

            {/* INFO */}
            <div className="product-info">
              <h4 className="card-heading">{item.title}</h4>
              <p className="section-text">{item.desc}</p>

              {/* FEATURES */}
              <motion.ul
                className="feature-list"
                variants={featureContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                {item.features.map((feature, i) => (
                  <motion.li
                    key={i}
                    className="feature-item"
                    variants={featureItem}
                  >
                    <div className="check-circle">
                      <span className="check-icon">✓</span>
                    </div>
                    {feature}
                  </motion.li>
                ))}
              </motion.ul>

              <a href={`/products${item.path}`} className="view-details">
                View Product Details
              </a>
            </div>

          </motion.div>
        ))}
      </motion.div>

    </section>
  );
};

export default Products;